/*
  Envio ao Zé Spot (rota /e/produto), pelo pocket que a página já carrega.

  O DEX manda ao Mixpanel por `window.mixpanel.track`, sem o POCKET, então o envio que o
  pocket faz sozinho não vê estes eventos. Este módulo entrega ao `POCKET.zespot` só o que
  está em `ZESPOT_ACEITOS`: hoje o `Exercise Answered`, que entra na régua de consumo do
  aluno ativo (DAU/WAU/MAU) do Data & Growth (ATV-202610011533).

  Regras:
  - `userEmail` e `userName` nunca saem daqui (a porta também os remove);
  - `application: 'dex'` marca a origem no próprio evento, e `origem: 'dex'` faz o mesmo
    pelo pocket 1.16.14+;
  - telemetria nunca derruba a página: qualquer falha é engolida.
*/

export const ZESPOT_ACEITOS = ["exercise answered"];

const SEM_DADO_PESSOAL = ["userEmail", "userName"];

let configurado = false;

function zespotDaPagina(): any {
  const pocket = typeof window !== "undefined" ? (window as any).POCKET : null;
  const zespot = pocket ? pocket.zespot : null;
  return zespot && typeof zespot.enviar === "function" ? zespot : null;
}

export function enviarAoZeSpot(eventName: string, data: any): boolean {
  try {
    if (ZESPOT_ACEITOS.indexOf(String(eventName).trim().toLowerCase()) < 0) return false;
    const zespot = zespotDaPagina();
    if (!zespot) return false;
    if (!configurado && typeof zespot.configurar === "function") {
      zespot.configurar({ aceitos: ZESPOT_ACEITOS.slice(), origem: "dex" });
      configurado = true;
    }
    const props: any = { application: "dex" };
    Object.keys(data || {}).forEach((k) => {
      if (SEM_DADO_PESSOAL.indexOf(k) < 0) props[k] = data[k];
    });
    zespot.enviar(eventName, props, { userId: props.userId });
    return true;
  } catch (e) {
    return false;
  }
}

/** Só para os testes: cada teste é uma página nova. */
export function reiniciarParaTeste(): void {
  configurado = false;
}
